import { keyframes } from '@emotion/react';
import { MARGINS_BLOCKS } from '@features/cms/const';
import { TMarginsTypes } from '@features/cms/typescript';
import theme from '@styles/theme';
const scrollLogoAnimation = keyframes({
  from: {
    transform: 'translateX(0)'
  },
  to: {
    transform: 'translateX(-50%)'
  }
});
export default {
  container: (background: string, marginTop: TMarginsTypes, marginBottom: TMarginsTypes) => ({
    background: background || '#ffffff',
    pt: MARGINS_BLOCKS[marginTop],
    pb: MARGINS_BLOCKS[marginBottom],
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    width: '100%',
    overflow: 'hidden',
    pl: ['16px', '16px', '24px', ' 24px', '13.75vw', '10.763888889vw'],
    pr: ['16px', '16px', '24px', ' 24px', '13.75vw', '10.763888889vw']
  }),
  wrapper: (active: boolean) => ({
    display: 'flex',
    flexDirection: 'row',
    overflow: active ? 'visible' : 'hidden'
  }),
  innerWrapper: (active: boolean) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '40px',
    width: !active ? '100%' : 'max-content',
    flexShrink: 0,
    transform: 'translate3d(0, 0, 0)',
    ...(active ? {
      animation: `${scrollLogoAnimation} 80s infinite linear`
    } : {})
  }),
  /** Jedna sekcja logo; paddingRight = gap między ostatnim a pierwszym kolejnej kopii (seamless loop przy translateX -50%). */
  logoStrip: (active: boolean) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '40px',
    gap: '80px',
    flexShrink: 0,
    paddingRight: '80px',
    ...(!active ? {
      justifyContent: 'space-between',
      width: '100%'
    } : {})
  }),
  logoStripClone: (active: boolean) => ({
    display: active ? 'flex' : 'none',
    flexDirection: 'row',
    alignItems: 'center',
    height: '40px',
    gap: '80px',
    flexShrink: 0,
    paddingRight: '80px',
    ...(!active ? {
      justifyContent: 'space-between',
      width: '100%'
    } : {})
  }),
  icon: {
    height: '40px',
    width: 'auto',
    svg: {
      height: '40px',
      width: 'auto'
    }
  }
};